import React from 'react';
import clsx from 'clsx';

import { Toggle as StyledToggle, Thumb } from './wrappers';
import { TimesIcon, CheckIcon } from '../Icon';

interface IToggle {
  onClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
  title: string;
  isActive?: boolean;
  disabled?: boolean;
  'data-testid'?: string;
}

const Toggle = ({ onClick, title, isActive, disabled = false, 'data-testid': testId }: IToggle) => (
  <StyledToggle
    aria-checked={isActive ? 'true' : 'false'}
    className={clsx(isActive && 'is-active')}
    onClick={onClick}
    style={disabled ? { pointerEvents: 'none', opacity: 0.5 } : undefined}
    title={title}
    data-testid={testId}
    type="button">
    <Thumb>{isActive ? <CheckIcon className="large" /> : <TimesIcon />}</Thumb>
  </StyledToggle>
);

export default Toggle;
